import styled from 'styled-components';
import { grey } from '../../../../styles/colors';
import { Exo } from '../../../../styles/fonts';
import { fromLarge } from '../../../../styleUtils/mediaQueries';
import { gridDisplay, gridTemplateRows, gridTemplateColumns } from 'styleUtils/grid';

export const PersonWrapper = styled.div`
    ${gridDisplay()}
    ${gridTemplateRows('auto')}
    ${gridTemplateColumns('50px 1fr')}

    align-items: center;
    line-height: normal;
    color: ${grey};
    font-size: 0.9em;
    text-transform: uppercase;
    font-family: ${Exo};
    ${fromLarge`
      ${gridTemplateColumns('max-content auto')}
    `};
`;
